import React, { useState } from "react";
import "./TaxiForSaleMainPagedes.css"; // קובץ CSS לעיצוב

const MAX_CHARACTERS = 100; // מספר תווים מקסימלי לפני הצגת "עוד.."

const TaxiForSaleMainPagedes = ({ taxi }) => {
    const [expanded, setExpanded] = useState(false);

    if (!taxi || !taxi["תיאור"]) return <p>🚕 נתונים לא זמינים</p>;

    const description = taxi["תיאור"];
    const isLongText = description.length > MAX_CHARACTERS; // בדיקה אם התיאור ארוך

    return (
        <div className="taxi-main-descripation">
            <div className="TaxiForsaleTitle"></div>
            <div className={`TaxiforsaledescripationDetails ${expanded ? "expanded" : ""}`}>
                <p>{expanded || !isLongText ? description : description.substring(0, MAX_CHARACTERS) + "..."}</p>

                {isLongText && (
                    <span className="read-more" onClick={() => setExpanded(!expanded)}>
                        {expanded ? "סגור" : "עוד.."}
                    </span>
                )}
            </div>
        </div>
    );
};

export default TaxiForSaleMainPagedes;
